import React from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col } from 'reactstrap';
import { Image } from 'site-modules/shared/components/image/image';
import { SOURCES } from 'client/utils/image-helpers';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { get } from 'lodash-es';
import { VehicleModel } from 'client/data/models/vehicle';

export function VehicleSelectorViewUI({ vehiclePhoto = '', style = null, onChange, onDelete }) {
  if (!style) {
    return null;
  }

  const { makeName, modelName, year, name: styleName } = style;
  const title = `${year} ${makeName} ${modelName}`;

  return (
    <Row className="vehicle-selector-view align-items-center mb-1_5">
      <Col xs={4} md={2}>
        <Image imageId={vehiclePhoto} className="img-fluid" alt={title} source={SOURCES.MEDIA} />
      </Col>
      <Col xs={8} md={10}>
        <div className="fw-bold">{title}</div>
        <div>{styleName}</div>
        <div>
          <Button color="link" className="text-primary p-0 me-1 text-capitalize fw-normal" onClick={onDelete}>
            Delete
          </Button>
          <Button color="link" className="text-primary p-0 text-capitalize fw-normal" onClick={onChange}>
            Change
          </Button>
        </div>
      </Col>
    </Row>
  );
}

VehicleSelectorViewUI.propTypes = {
  vehiclePhoto: PropTypes.string,
  style: PropTypes.shape({
    makeName: PropTypes.string,
    modelName: PropTypes.string,
    year: PropTypes.number,
    id: PropTypes.number,
    name: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export const stateToPropsConfig = {
  vehiclePhoto: bindToPath(({ style }) => {
    const styleId = get(style, 'id');
    return styleId ? `styles.${styleId}.photo` : '';
  }, VehicleModel),
};

export const VehicleSelectorView = connectToModel(VehicleSelectorViewUI, stateToPropsConfig);
